export default __webpack_public_path__ + "static/17-ce95db4d6bec9c5606f41d59b144e8d4.jpg";